import script from "./SlideVerify.vue?vue&type=script&setup=true&lang=js"
export * from "./SlideVerify.vue?vue&type=script&setup=true&lang=js"

import "./SlideVerify.vue?vue&type=style&index=0&id=59fa4f28&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59fa4f28"]])

export default __exports__